import { List, Record } from "immutable";

import { AccessReviewReportModel } from "./AccessReviewReportModel";
import { type AccessReviewTemplateModel } from "./AccessReviewTemplateModel";

export interface IAccessReviewPermissionsStatistics {
  permissionsStatus: {
    approved: number;
    denied: number;
    deniedManaged: number;
    deniedUnmanaged: number;
    flagged: number;
    pending: number;
  };
}

interface IAccessReviewStatistics extends IAccessReviewPermissionsStatistics {
  reportsStatus: {
    done: number;
    inProgress: number;
    pending: number;
  };
}

const defaults = {
  createdAt: new Date(0),
  creatorId: "",
  description: "",
  id: "",
  immediateRevoke: false,
  name: "",
  permissionCount: null as null | number,
  reports: null as List<AccessReviewReportModel> | null,
  reportsCount: null as null | number,
  statistics: null as IAccessReviewStatistics | null,
  status: "" as "active" | "created" | "done" | "pendingCreation",
  template: null as AccessReviewTemplateModel | null,
  templateId: "",
};

export class AccessReviewModel extends Record<typeof defaults>(defaults) {
  public get permissionsSize(): number {
    if (typeof this.permissionCount === "number") return this.permissionCount;
    if (this.statistics) {
      return Object.values(this.statistics.permissionsStatus).reduce((a, b) => a + b, 0);
    }
    return 0;
  }

  public get reportsSize(): number {
    return this.reportsCount || this.reports?.size || 0;
  }

  static fromServerData(data: unknown): AccessReviewModel {
    const {
      createdAt,
      creatorId,
      description,
      id,
      immediateRevoke,
      name,
      permissionCount,
      reports,
      reportsCount,
      statistics,
      status,
      template,
      templateId,
    } = data as typeof defaults;
    return new AccessReviewModel({
      createdAt: new Date(createdAt),
      creatorId,
      description,
      id,
      immediateRevoke,
      name,
      permissionCount,
      reports: reports ? List(reports.map(AccessReviewReportModel.fromServerData)) : null,
      reportsCount: reportsCount,
      statistics,
      status,
      template,
      templateId,
    });
  }
}
